import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import Loading from 'modules/layout/components/Page/Loading'
import { Steps } from 'modules/processes/components/ProcessSettings/Steps'
import { StepsProvider } from 'modules/processes/components/ProcessSettings/Steps/StepsProvider'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'
import { useProcessDetail } from 'modules/processes/pages/Process/ProcessRootPage/useProcessDetail'
import Header from 'modules/processes/pages/Process/components/Header'

const ProcessSettingsPage = () => {
  // Here we have loaded only the basic process data (pure process info)
  const { process: processContext, template } = useProcessContext()

  // Here we load the process details (steps, items, etc)
  const { process, loading } = useProcessDetail({ id: processContext.id })

  useEffect(() => {
    if (process?.category)
      track(trackingEvents.processes.processConfigOpened, { category: process?.category })
  }, [process?.category])

  if (!process || loading) return <Loading />

  return (
    <>
      <Box>
        <Header process={process} />
      </Box>
      <Box paddingY="s24" gap="s16">
        <StepsProvider initialState={process.steps}>
          <Steps />
        </StepsProvider>
      </Box>
      <Outlet context={{ process, template }} />
    </>
  )
}

export default ProcessSettingsPage
